import { useCallback, useEffect } from 'react';

import { useUser } from '@clerk/react';

import { useTeamMembers } from '../../context/TeamMembersContext';
import { useGetStats } from '../../services/stats.service';
import { useGTMStore } from '../../store';
import {
  calculateEmailVolumeBucket,
  setGTMUserProperties,
} from '../../utils/gtm/userProperties';

export const useGTMUserProperties = () => {
  const { user } = useUser();
  const { state: teamState } = useTeamMembers();
  const { refetch: refetchStats } = useGetStats();

  const userPropertiesSet = useGTMStore((state) => state.userPropertiesSet);
  const setUserPropertiesSet = useGTMStore(
    (state) => state.setUserPropertiesSet,
  );
  const resetUserPropertiesSet = useGTMStore(
    (state) => state.resetUserPropertiesSet,
  );

  const updateUserProperties = useCallback(async () => {
    if (!user || userPropertiesSet) return;

    setUserPropertiesSet(true);

    try {
      const stats = await refetchStats();
      const statsArray = stats?.data?.getStats;
      const emailBucket = calculateEmailVolumeBucket(statsArray);
      const teamCount = teamState.userTeamIds?.length ?? 0;

      setGTMUserProperties(user, emailBucket, teamCount);
    } catch {
      resetUserPropertiesSet();
    }
  }, [
    user,
    userPropertiesSet,
    setUserPropertiesSet,
    resetUserPropertiesSet,
    refetchStats,
    teamState.userTeamIds,
  ]);

  useEffect(() => {
    if (!user) {
      resetUserPropertiesSet();
    }
  }, [user, resetUserPropertiesSet]);

  useEffect(() => {
    if (user && !userPropertiesSet) {
      updateUserProperties();
    }
  }, [user, userPropertiesSet, updateUserProperties]);
};
